export const COMPONENT_NAME = "admin-kyc-status";
